export const getDefaultState = () => {
  return {
    loading: {},
    brands: [],
    errorMessage: ""
  }
};